import type { ProductSummaryStatus, StoreProductStatus } from '@nucleus-commerce/api-client/admin';

/** What shoppers of one store get right now, from the store's status and the master's. */
export type StoreProductLiveState =
  | { kind: 'live' }
  | { kind: 'scheduled'; at: string }
  | { kind: 'hidden'; master: Exclude<ProductSummaryStatus, 'active'> }
  | { kind: 'draft' }
  | { kind: 'unpublished' };

export interface StoreProductLiveInput {
  status: StoreProductStatus;
  masterStatus: ProductSummaryStatus;
  /** When the worker publishes it; only pending times are kept, it clears once it fires. */
  publishAt: string | null;
}

/**
 * Published here is live only while the master product is active. Anything else with a publish
 * time waits for it, and the rest is what its own status says.
 */
export function storeProductLiveState({
  status,
  masterStatus,
  publishAt,
}: StoreProductLiveInput): StoreProductLiveState {
  if (status === 'published') {
    return masterStatus === 'active' ? { kind: 'live' } : { kind: 'hidden', master: masterStatus };
  }
  if (publishAt) return { kind: 'scheduled', at: publishAt };
  return { kind: status };
}

/** Whether shoppers of the store can buy it now; false for a store that doesn't have it. */
export function isLiveInStore(
  row: Pick<StoreProductLiveInput, 'status' | 'publishAt'> | null | undefined,
  masterStatus: ProductSummaryStatus,
): boolean {
  return row != null && storeProductLiveState({ ...row, masterStatus }).kind === 'live';
}
